import posthog from 'posthog-js';
import { isProduction, isStaging, posthogProjectApiKey } from './env-config';
export let postHogSingleton;
export const initPostHog = () => {
    if (typeof window === 'undefined' ||
        !posthogProjectApiKey ||
        !(isProduction || isStaging)) {
        return undefined;
    }
    if (postHogSingleton)
        return;
    posthog.init(posthogProjectApiKey, {
        api_host: 'https://app.posthog.com',
        loaded: (posthog) => {
            posthog.register({
                appVersion: process.env.APP_VERSION,
            });
        },
    });
    return (postHogSingleton = posthog);
};
